import { BoundingBox } from "@/types/util"

export function getMapDivSize(map: google.maps.Map) {
  const mapDiv = map.getDiv()

  if (
    !mapDiv ||
    typeof mapDiv.offsetWidth !== "number" ||
    typeof mapDiv.offsetHeight !== "number"
  ) {
    return null
  }

  return {
    width: mapDiv.offsetWidth,
    height: mapDiv.offsetHeight,
  }
}

export function getMapPixelSize(map: google.maps.Map, bounds: BoundingBox) {
  const mapDivSize = getMapDivSize(map)
  if (!mapDivSize) return null
  const { width, height } = mapDivSize
  const diffLat = Math.abs(bounds[1] - bounds[3])
  const diffLng = Math.abs(bounds[0] - bounds[2])
  return {
    pixelPerLat: height / diffLat,
    pixelPerLng: width / diffLng,
  }
}

/** Map-div pixel coordinates for a lat/lng within the current bounds. */
export function latLngToMapDivPixels(
  latitude: number,
  longitude: number,
  bounds: BoundingBox,
  pixelPerLat: number,
  pixelPerLng: number
) {
  return {
    posX: Math.abs(bounds[0] - longitude) * pixelPerLng,
    posY: Math.abs(bounds[1] - latitude) * pixelPerLat,
  }
}
